export default __webpack_public_path__ + "b09db9a10e9123b787720d29b481a03c.svg";